module.exports = __webpack_public_path__ + "static/totalfootcare-4420cae5aa0b0ac27384669e8377e059.jpg";